import axiosInstance from './api';

export const getEmailAlerts = () => {
  return axiosInstance.get('/settings/alerts')
}

export const updateEmailAlerts = (data) => {
  return axiosInstance.put('/settings/alerts', data)
}